import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AuthCallback from "@/pages/AuthCallback";
import Layout from "@/components/Layout";
import PublicPreventivo from "@/pages/PublicPreventivo";
import Dashboard from "@/pages/Dashboard";
import Pazienti from "@/pages/Pazienti";
import Calendario from "@/pages/Calendario";
import AgendaCollaboratore from "@/pages/AgendaCollaboratore";
import Gestione from "@/pages/Gestione";
import Analytics from "@/pages/Analytics";
import Preventivi from "@/pages/Preventivi";
import Incassi from "@/pages/Incassi";
import Profilo from "@/pages/Profilo";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-10 w-10 rounded-full border-4 border-primary/30 border-t-primary animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Emergent Google OAuth returns to {origin}/dashboard#session_id=...
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/p/preventivo/:token" element={<PublicPreventivo />} />
      <Route
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/calendario" element={<Calendario />} />
        <Route path="/agenda" element={<AgendaCollaboratore />} />
        <Route path="/pazienti" element={<Pazienti />} />
        <Route path="/preventivi" element={<Preventivi />} />
        <Route path="/incassi" element={<Incassi />} />
        <Route path="/gestione" element={<Gestione />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/profilo" element={<Profilo />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
